import { Alert as MuiAlert, Snackbar } from '@mui/material';
import React from 'react';

import { useAlertState, useAlertUpdater } from '../../context/AlertContext';

const classes = {
	message: {
		padding: '8px 0',
		fontSize: '16px',
	},
};

const Alert = () => {
	const { open, message, severity } = useAlertState();
	const { onClose } = useAlertUpdater();

	const handleClose = () => onClose();

	return (
		<>
			<Snackbar
				open={open}
				autoHideDuration={6000}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<div className={classes.message}>
					<MuiAlert
						label="alert for form save"
						elevation={6}
						variant="filled"
						onClose={handleClose}
						severity={severity}
						data-testid="alert_message"
					>
						{message}
					</MuiAlert>
				</div>
			</Snackbar>
		</>
	);
};

export default Alert;
